// common shared code and configuration

export * from "./api/gql/index"
export * from "./data/tenants"
export * from "./config/index"
export * from "./types/index"
export * from "./util/collections"
export * from "./util/error"
export * from "./util/misc"
export * from "./util/index"
export * from "./uuid"
export * from "./ulid"
export * from "./domain/candidate"
export * from "./domain/mail"

export const APP_DISPLAY_NAME = "Tombo AI"
